<template>
  <group class="auction_info_item" v-if="auction.status_code === 'pending'">
    <cell class="auction_status">
      <span slot="after-title" class="fc_red">{{auction.auction_session_name}}</span>
      <span slot="value" class="status">{{statusList[auction.status_code]}}</span>
    </cell>
    <div class="price_msg price_msg--special">
      <p class="price_msg__item">起拍价：{{minimumPrice | formateTenThousandPrice}}万元</p>
      <p class="price_msg__item">保留价：{{reservePrice | formateTenThousandPrice}}万元</p>
    </div>
    <ul class="detail">
      <li>说明：</li>
      <li>每拍一辆车，需冻结保证金{{ frozenAmount | transformMoney }}元。请提醒您所邀请车商提前充值。</li>
    </ul>
    <div class="link">
      <router-link to="/protocol/auction">拍卖规则</router-link>
    </div>
  </group>

  <group class="auction_info_item" v-else-if="auction.status_code === 'bidding'">
    <cell class="auction_status">
      <span slot="after-title" class="fc_gray" :class="warning">拍卖剩余时间<i class="num">{{minute}}</i>分<i class="num">{{second}}</i>秒</span>
      <span slot="value" class="status auctioning">{{statusList[auction.status_code]}}</span>
    </cell>
    <div class="price_msg">
      <p class="price_msg__item">起拍价：{{minimumPrice | formateTenThousandPrice}}万元</p>
      <p class="price_msg__item">保留价：{{reservePrice | formateTenThousandPrice}}万元</p>
    </div>
    <p class="price_info">当前价<span class="fc_price">{{auction.cur_max_price | formatePrice}}</span>元，{{auction.great_reserve_price ? '已过保留价' : '未过保留价'}}</p>
  </group>

  <group class="auction_info_item" v-else>
    <cell class="auction_status">
      <span slot="after-title" class="fc_gray">{{priceName}}<i class="fc_price">{{auction.cur_max_price | formatePrice}}</i>元</span>
      <span slot="value" class="status" :class="success">{{statusList[auction.status_code]}}</span>
    </cell>
    <div class="price_msg price_msg--special">
      <p class="price_msg__item">起拍价：{{minimumPrice | formateTenThousandPrice}}万元</p>
      <p class="price_msg__item">保留价：{{reservePrice | formateTenThousandPrice}}万元</p>
    </div>
    <cell class="auction_process">
      <div slot="after-title">
        <p class="fc_gray">此车在 {{auction.finished_at}} 竞拍结束</p>
        <p class="fc_red fs26" v-if="auction.winner">中标人：{{`${auction.winner.name} ${auction.winner.mobile_number} ${auction.winner.city}`}} </p>
      </div>
    </cell>
    <cell class="auction_status">
      <span slot="after-title" class="fc_gray" v-if="auction.next_auction_id">系统将在<i class="fc_red">5</i>秒后为你跳入下一辆车</span>
      <span slot="after-title" v-else class="fc_gray">本场竞拍已全部结束</span>
    </cell>
  </group>
</template>
<script>
import {
  Group,
  Cell
} from '@lx-frontend/cvux'
export default {
  components: {
    Group,
    Cell
  },
  props: {
    auction: {
      type: Object,
      default() {
        return {
          winner: {}
        }
      }
    },
    frozenAmount: {
      type: Number,
      default: 0
    },
    minimumPrice: {
      type: Number,
      default: 0
    },
    reservePrice: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      minute: 0,
      second: 0,
      timeout: null,
      statusList: {
        pending: '等待开拍',
        bidding: '竞拍中',
        unsold: '车辆流拍',
        sold: '车辆成交',
        completed: '已收款',
        closed: '已关闭'
      }
    }
  },
  filters: {
    formatePrice(val) {
      return (+val / 100).toFixed(2)
    },
    formateTenThousandPrice(val) {
      return (+val / 1000000).toFixed(2)
    }
  },
  computed: {
    priceName() {
      return this.auction.status_code === 'unsold' ? '最高价' : '成交价'
    },
    success() {
      if (this.auction.status_code === 'sold' || this.auction.status_code === 'completed') {
        return 'success'
      }
      return ''
    },
    warning() {
      if (this.auction.ms_to_end < 20000) {
        return 'warning'
      }
      return ''
    }
  },
  watch: {
    'auction.ms_to_end'(val) {
      if (val <= 0) return false
      let secondsToEnd = val / 1000
      let minute = Math.floor(secondsToEnd / 60)
      let second = Math.floor(secondsToEnd % 60)
      if (minute < 10) {
        minute = '0' + minute
      }
      if (second < 10) {
        second = '0' + second
      }
      this.minute = minute
      this.second = second
    }
  }
}

</script>
<style lang="less">
@import "../../stylesheets/modules/components/auctionInfo.less";
</style>
